import React from 'react';
import './Loading.css';

const Loading = () => {
    return (
        <div class="patterns">
            <svg width="100%" height="100%">
                <text x="50%" y="60%" text-anchor="middle"  >
                    ZIM
                </text>
            </svg>
        </div>
    );
};

export default Loading;